import React from "react";
import PropTypes from "prop-types";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import {
  MSWordIcon,
  MSExcelIcon,
  MSPowerPointIcon,
  MarkdownIcon,
  PDFIcon,
  TxtFileIcon,
} from "../../resources/icons";

const SimpleFileIcon = ({fileName, className}) => {
  const ext = fileName?.split(".").pop()?.toLowerCase();

  switch (ext) {
    case "csv":
    case "xlsx":
    case "xls":
      return <MSExcelIcon className={className} />;
    case "docx":
    case "doc":
      return <MSWordIcon className={className} />;
    case "pptx":
    case "ppt":
      return <MSPowerPointIcon className={className} />;
    case "md":
      return <MarkdownIcon className={className} />;
    case "pdf":
      return <PDFIcon className={className} />;
    case "txt":
      return <TxtFileIcon className={className} />;
    default:
      return <DescriptionOutlinedIcon className={className} fontSize="large" />;
  }
};

SimpleFileIcon.propTypes = {
  fileName: PropTypes.string,
  className: PropTypes.string,
};

export default SimpleFileIcon;
